import React from "react";

interface ErrorMessageProps {
  children: React.ReactNode;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ children }) => {
  return (
    <small className="text-danger mt-1 d-block fw-medium">{children}</small>
  );
};
